import { ValidationErrorDetails } from '../validation-error-details';

export class NumberValidatorResult {
  public isNotNumber: ValidationErrorDetails;
  public isTooBig: ValidationErrorDetails;
  public isTooSmall: ValidationErrorDetails;
  public isNegative: ValidationErrorDetails;
  public hasRedundantDecimals: ValidationErrorDetails;
}
